/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useRecoilValue } from 'recoil'

import { userState } from '../state/userState'

export const useUser = () => useRecoilValue(userState)!